import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';

import AddEditOutlets from './AddEditOutlets';
import ActiveInactiveDialog from '../../components/ActiveInactiveDialog';

const Outlets = () => {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allOutlets, setAllOutlets] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const handleInputSwitch = async () => {
        setLoadingBtn(true);
        const data = { isActive: !switchData?.isActive };

        const response = await dispatch(handlePutRequest(data, endPoints.updateOutlet, false, true));
        if (response?.status === 200) {
        }

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => (
        <div className="actions">
            <InputSwitch
                tooltip="Status"
                checked={rowData?.isActive}
                onChange={() => {
                    setSwitchData(rowData);
                    handleSwitchModalOpen();
                }}
            />
            <Button icon="pi pi-pencil" tooltip="Edit" className="p-button-rounded p-button-primary mx-2" onClick={() => handleEdit(rowData)} />
            <Button icon="pi pi-eye" tooltip="View" className="p-button-rounded" style={{ backgroundColor: '#F2AC57', border: 'none' }} onClick={() => handleView(rowData)} />
        </div>
    );

    const registeredOnTemplate = (rowData) => {
        const date = new Date(rowData?.registeredOn);
        return date ? <span>{date.toLocaleDateString()}</span> : '';
    };

    const onHide = () => {
        setShowAddDialog(false);
    };

    const onCancel = () => {
        setShowAddDialog(false);
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Merchant Stores/Outlets</h3>
                <div className="flex gap-2">
                    <Button icon="pi pi-file-excel" className="p-button-sm" style={{ backgroundColor: '#B388EB', border: 'none' }} tooltip="Export CSV" />
                    <Button icon="pi pi-print" className="p-button-sm" style={{ backgroundColor: '#B388EB', border: 'none' }} tooltip="Print" />
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />
                </div>
            </div>

            <Dialog header={editable ? 'Edit Outlet' : viewable ? 'View Outlet' : 'Add Outlet'} visible={showAddDialog} onHide={onCancel} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                <AddEditOutlets rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onCancel={onCancel} />
            </Dialog>

            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />

            <DataTable
                value={allOutlets}
                paginator
                rows={10}
                emptyMessage="No data available in table"
                responsiveLayout="scroll"
                className="p-datatable-sm"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
                <Column field="identifier" header="Identifier" />
                <Column field="name" header="Name" />
                <Column field="location" header="Location" />
                <Column field="isDefault" header="Default" />
                <Column field="isActive" header="Active" body={(data) => (data.isActive ? 'Yes' : 'No')} />
                <Column field="registeredOn" header="Registered On" body={registeredOnTemplate} />
                <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
        </div>
    );
};

export default Outlets;
